module.exports = __webpack_public_path__ + "img/01.2aa9cc25.jpg";